import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import './ThankYouPage.css';

const ThankYouPage = () => {
  const { submissionId } = useParams();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const amazonStorefrontUrl = 'https://www.amazon.com/shop/uga2030uni?ccs_id=6ca97af5-bb61-40c9-8b85-492aaf761fe8';

  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <Card className="thank-you-card">
          {/* Success Icon */}
          <div className="thank-you-icon">
            <i className="pi pi-check-circle"></i>
          </div>

          {/* Thank You Message */}
          <h1 className="thank-you-title">Thank You for Your Order!</h1>
          <p className="thank-you-message">
            Your submission has been received and will be posted according to your selected tier. 
            We appreciate your support and wish you all the best!
          </p>

          {/* Divider */}
          <div className="thank-you-divider"></div>

          {/* Amazon Storefront Section */}
          <div className="amazon-section">
            <h2 className="amazon-title">Shop Our Collection</h2>
            <p className="amazon-description">
              While you wait, check out our curated collection of college essentials on Amazon!
            </p>
            
            <a 
              href={amazonStorefrontUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="amazon-link-wrapper"
            >
              <Button
                label="Browse Our Amazon Store"
                icon="pi pi-shopping-cart"
                className="amazon-button"
                size="large"
              />
            </a>

            <p className="amazon-note">
              <i className="pi pi-info-circle"></i>
              Find everything you need for college life - from dorm essentials to study gear!
            </p>
          </div>

          {/* Footer Note */}
          <div className="thank-you-footer">
            <p>Questions? Contact us at support@unipostings.com</p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ThankYouPage;

